/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_preview_alert_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `This item is not published. What you are seeing here is only a preview. You can see this because you have access to the item. It cannot be viewed publicly.`
};

const fr_preview_alert_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `Cet élément n'est pas publié. Ce que vous voyez ici n'est qu'un aperçu. Vous pouvez le voir car vous y avez accès. Il ne peut pas être consulté publiquement.`
};

const de_preview_alert_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `Dieser Artikel ist nicht veröffentlicht. Was Sie hier sehen, ist lediglich eine Vorschau. Sie können diese sehen, da Sie Zugriff auf den Artikel haben. Er ist nicht öffentlich einsehbar.`
};

const es_preview_alert_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `Este artículo no está publicado. Lo que estás viendo aquí es solo una vista previa. Puedes ver esto porque tienes acceso al artículo. No se puede ver públicamente.`
};

const it_preview_alert_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `Questo elemento non è pubblicato. Ciò che vedi qui è solo un'anteprima. Puoi vederlo perché hai accesso all'elemento. Non può essere visualizzato pubblicamente.`
};

const ar_preview_alert_description23 = /** @type {(inputs: {}) => string} */ () => {
	return `هذا العنصر غير منشور. ما تراه هنا هو مجرد معاينة. يمكنك رؤية هذا لأنه يمكنك الوصول إلى العنصر. لا يمكن عرضه علنًا.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const preview_alert_description23 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.preview_alert_description23(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("preview_alert_description23", locale)
	if (locale === "en") return en_preview_alert_description23(inputs)
	if (locale === "fr") return fr_preview_alert_description23(inputs)
	if (locale === "de") return de_preview_alert_description23(inputs)
	if (locale === "es") return es_preview_alert_description23(inputs)
	if (locale === "it") return it_preview_alert_description23(inputs)
	return ar_preview_alert_description23(inputs)
};
export { preview_alert_description23 as "PREVIEW_ALERT_DESCRIPTION" }